import React from 'react';
import { useNavigate } from 'react-router-dom';
import LogoBlanc from '../components/LogoBlanc';

import NavigationMenu from '../components/NavigationMenu';
import './Pedagogie.css';

const Pedagogie = () => {
  const navigate = useNavigate();

  return (
    <div className="ped-container">
      <NavigationMenu />
      <LogoBlanc />

      <h1 style={{
        position: 'fixed', top: '2.7rem', right: '60px',
        fontFamily: "'Source Sans 3', sans-serif",
        fontSize: 'clamp(2.5rem, 4vw, 3rem)', fontWeight: 300,
        color: 'rgba(255,255,255,0.55)', letterSpacing: '0.2rem',
        textAlign: 'right', textTransform: 'uppercase',
        margin: 0, pointerEvents: 'none', zIndex: 1000, lineHeight: 1,
      }}>Pédagogie</h1>

      {/* Contenu principal */}
      <div className="ped-content">
        <div className="ped-buttons">
          <button
            className="ped-btn"
            onClick={() => navigate('/references')}
          >
            Répertoire de références
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pedagogie;